import type { EmotionCache } from '@emotion/react';
import { CacheProvider } from '@emotion/react';
import type { FC, PropsWithChildren } from 'react';
import { createEmotionCache } from '@/lib/emotion';
import { ThemeProvider } from 'ThemeProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { NextStepProvider } from 'nextstepjs';

// @ts-ignore
import i18n from './i18n';
// force import of i18n
const _ = i18n;

type Props = PropsWithChildren<{
  /**
   * Optional emotion/cache to use
   */
  emotionCache?: EmotionCache;
}>;

// Client-side cache, shared for the whole session of the user in the browser.
const clientSideEmotionCache = createEmotionCache();

export const AppProviders: FC<Props> = (props) => {
  const { children, emotionCache = clientSideEmotionCache } = props;
  return (
    <CacheProvider value={emotionCache as any}>
      <ThemeProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <NextStepProvider>{children}</NextStepProvider>
        </LocalizationProvider>
      </ThemeProvider>
    </CacheProvider>
  );
};
